import { useState } from 'react';
import { Box, ClickableBox, Flex } from './ui';
import chevronUp from 'img/chevron-up.svg';
import chevronDown from 'img/chevron-down.svg';
import styled from 'styled-components';
import React from 'react';
import { useCallback } from 'react';

interface CollectionFilterAccordionProps {
  title: string;
  children: React.ReactNode;
  iconSrc?: string;
}

interface AccordeonProps {
  open: boolean;
}

const Accordeon = styled(ClickableBox)<AccordeonProps>`
    width: 100%;
    background: black;
    border-bottom: 1px solid #333;
    padding: 10px;

    &:hover {
      border-bottom: 1px solid black;
      border-top: 1px solid black;
      background: ${(props) => props.open ? 'black' : '#333'};
    }
`;

// Renders an accordion for usage in the collection filters.
const CollectionFilterAccordion = ({
  title,
  children,
  iconSrc,
}: CollectionFilterAccordionProps) => {
  const [open, setOpen] = useState(false);

  const handleAccordeonClick = useCallback(() => {
    setOpen(!open);
  }, [open]);

  return (
    <Box width="100%">
      <Accordeon open={open} onClick={handleAccordeonClick}>
        <Flex justifyBetween alignCenter>
          <Flex flexGrow={1}>
            {iconSrc && <img src={iconSrc} alt={title} width="24px" />}
            <Box marginLeft={!iconSrc ? '' : '15px'}>{title}</Box>
          </Flex>
          <img src={open ? chevronUp : chevronDown} alt="v" />
        </Flex>
      </Accordeon>
      {open && <Box background="#333">{children}</Box>}
    </Box>
  );
};

export default CollectionFilterAccordion;